import XTbl,{Xtc} from '../../../../components/x-table/index';
const tbl = new XTbl('/contact/query/removed/', 'Contacts');

tbl.add(new Xtc('profile', 'Profile').renderSlot('profile'))
tbl.add(new Xtc('person', 'Full name').renderSlot('fullname'))
tbl.add(new Xtc('person.first_name', 'First name'))
tbl.add(new Xtc('person.last_name', 'Last name'))
tbl.add(new Xtc('person.middle_name', 'Middle name').hidden())
tbl.add(new Xtc('company.name', 'Company'))
tbl.add(new Xtc('emails[0].email_address', 'Emails'))
tbl.add(new Xtc('phones[0].phone_number', 'Phone numbers'))
tbl.add(new Xtc('websites[0].website_address', 'Websites'))
tbl.add(new Xtc('addresses[0].city', 'City'))
tbl.add(new Xtc('addresses[0].country', 'Country').hidden())
tbl.add(new Xtc('addresses[0].post_code', 'Post code').hidden())
tbl.add(new Xtc('addresses[0].street', 'Street').hidden())
tbl.add(new Xtc('action', 'Action').noSort().renderSlot('action'))

export default tbl;

